import {
  Box,
  Button,

  useMediaQuery,
  useTheme,

} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useNavigation } from "react-router-dom";
import CategoryMenu from "../Categories/CategoryMenu";
import PostalCode from "../Common/PostalCode";
import { useLazyQuery } from "@apollo/client";
import { GENERAL_SEARCH } from "../../Utils/Queries";
import { useSelector } from "react-redux";
import andriod from "../../assets/images/andriod.svg";
import apple from "../../assets/images/apple.svg";
import aiIcon from "../../assets/Icons/calendar.svg";

import ShareEarn from "../Common/ShareEarn";
import MobileSearchDrawer from "./components/mobile-search-drawer";
import DesktopSearchPopup from "./components/desktop-search-popup";
import { recentSearch } from "../../assets/Data";
import EnhancedSearchDropdown from "./EnhancedSearchDropdown";

import useAuthFlow from "../../Hooks/use-auth-flow";

const FullSearchBar = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [searchData, setSearchData] = useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const [handleSearch, { loading, data, error }] = useLazyQuery(GENERAL_SEARCH);

  const handleChange = (event) => {
    setQuery(event.target.value);
    if (query && !isMobile) {
      setOpen(true);
      setAnchorEl(event.currentTarget);
    }
  };

  const renderHighlightedText = (text, highlights) => {
    if (!highlights || !highlights.value) return text;
    return highlights.value;
  };

  useEffect(() => {
    if (query.length < 1) {
      setAnchorEl(null);
      setOpen(false);
    }
    handleSearch({
      variables: {
        searchText: query,
      },
    });
  }, [query]);

  let filteredData = data?.searchGlobalInput || [];
  if (query !== "" && data) {
    filteredData = data?.searchGlobalInput?.filter(({ result }) => {
      return result?.name?.toLowerCase().includes(query?.toLowerCase());
    });
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? "transition-popper" : undefined;

  const [openDrawer, setOpenDrawer] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };

  const isSeller = useSelector(
    (state) => state.user?.user?.profile?.hasPaidMembershipFee,
  );

  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  // Navigate to search results page
  const navigateToSearchResults = (searchQuery) => {
    if (!searchQuery.trim()) return;

    // Close modal/drawer
    setOpen(false);
    setOpenDrawer(false);

    // Navigate to search results page
    navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
  };

   const { triggerAuth } = useAuthFlow();
     const router = useLocation();

  
  return (
    <>
      {/* {isAuthenticated && <ShareEarn />} */}
      <Box
      
        sx={{
         pt:{md:2, xs:0},
          pb: { xs: 0, sm: 0, md: 2, lg: 2 },
          display: "flex",
          alignItems: "center",
          borderTop: {md:"none", xs:"0.5px solid #ffffffb7"},
          bgcolor: { xs: "#2E1834", md: "#ffffff" },
      boxShadow: "0px 6px 12px -6px rgba(0,0,0,0.2)",
        }}
      >
        {isMobile ? (
          <>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  px: 2,
                  py: 1,
                }}
              >
                <div className="flex items-center justify-between">
                  <div className="w-[60%]">
                    <PostalCode />
                  </div>

                  {isAuthenticated ? (
                    <Link to="/ma-agent">
                      <div className="flex items-center gap-x-2 cursor-pointer">
                        <img alt="ai_icon" src={aiIcon} className="w-5 h-5" />
                        {/* <span className="text-[14px]">Ask Ma</span> */}
                      </div>
                    </Link>
                  ) : (
                   
                      <div onClick={()=>triggerAuth("signin")} className="flex items-center gap-x-2 cursor-pointer">
                        <img alt="ai_icon" src={aiIcon} className="w-5 h-5" />
                        {/* <span className="text-[14px]">Ask Ma</span> */}
                      </div>
                 
                  )}
                </div>

                {/* SEARCH COMPONENT */}
                <div className="mt-5 mb-2">
                  <EnhancedSearchDropdown
                    placeholder="Search culture, products, services, events, etc."
                    onSearch={(searchQuery) => setQuery(searchQuery)}
                    value={query}
                    enableNavigation={true}
                    style={{
                      textField: {
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#fff",
                          },
                        },
                      },
                    }}
                  />
                </div>
              </Box>
              <div className=" bg-white px-3 pt-2 pb-2">
                <div>
                  <CategoryMenu />
                </div>

             
              </div>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              margin: "0 auto",
              width: {
                xl: "75%",
                lg: "85%",
                md: "85%",
                sm: "100%",
                xs: "100%",
              },
             
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              
              columnGap:4
            }}
          >
            <div className="">
              <CategoryMenu />
            </div>

            <div className="flex items-center gap-x-5 max-w-[75%] overflow-y-auto hide_scrollbar">
              {NAVIGATION_LINKS.map((link) => (
                <Link
                  key={link.label}
                  to={link.path}
                  style={{ textDecoration: "none" }}
                >
                  <span className={`text-[#2E1834] text-[14px] hover:text-primary hover:font-bold transition-all whitespace-nowrap ${router?.pathname === link.path ? "font-[700] text-primary": "font-medium"}`}>
                    {link.label}
                  </span>
                </Link>
              ))}
            </div>

            <div className="flex items-center">
              {/* {isSeller ? (
                <Link to="/sell-on-mamaket" className="!text-primary">

                  <MaButton
                    sx={{ borderRadius: "50px", color:'white' }}
                    variant="primary"
                    title="Sell on Mamaket"
                  />
                </Link>
              ) : (
                <Link to="/download">
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "40px",
                      background: "#1a1a1a",
                      "&:hover": { background: "#1a1a1ab7" },
                    }}
                  >
                    Become A Seller
                  </Button>
                </Link>
              )} */}

              {/* {isAuthenticated ? ( */}
                <>
                  {/* <Button
                    variant="outlined"
                    sx={{
                      height: "46px",
                      borderRadius: "50px",
                      fontWeight: 600,
                      bgcolor: "#E2D3E6",
                      color: "#2E1834",
                      borderColor: "#2E1834",
                      whiteSpace:'nowrap'
                    }}
                  >
                    Explore Cultures
                  </Button> */}
                  {/* <Button
                    variant="outlined"
                    sx={{
                      height: "46px",
                      borderColor: "#C89B4F",
                      bgcolor: "#F5EDE0",
                      borderRadius: "50px",
                      color: "#0F0E0B",
                      fontWeight: 600,
                      ml: 2,
                    }}
                  >
                    Find Stores
                  </Button> */}
                </>

                <div className="flex-1 flex">
                  <a href="https://play.google.com/store/apps/details?id=com.mamaket.mobile2026">
                    <img
                      src={andriod}
                      alt="Download on Google Play"
                      width="120"
                      height="40"
                      loading="lazy"
                    />
                  </a>
                  <a href="https://apps.apple.com/ng/app/mamaket-mobile/id6469295262">
                    <img
                      src={apple}
                      alt="Download on Apple Store"
                      width="120"
                      height="40"
                      loading="lazy"
                    />
                  </a>
                </div>
              {/* )} */}
            </div>
          </Box>
        )}
      </Box>

      <DesktopSearchPopup
        handleClose={handleClose}
        data={data}
        anchorEl={anchorEl}
        id={id}
        query={query}
        filteredData={filteredData}
        navigateToSearchResults={navigateToSearchResults}
        open={open}
      />

      <MobileSearchDrawer
        openDrawer={openDrawer}
        toggleDrawer={() => toggleDrawer(false)}
        query={query}
        setQuery={setQuery}
        setSearchData={setSearchData}
        searchData={searchData}
        navigateToSearchResults={navigateToSearchResults}
        renderHighlightedText={renderHighlightedText}
        recentSearch={recentSearch}
      />
    </>
  );
};

export default FullSearchBar;

const NAVIGATION_LINKS = [
  { label: "Categories", path: "/categories" },
  { label: "Explore Culture", path: "/explore-culture" },
  { label: "About Mamaket", path: "/about-us" },
  { label: "Referral", path: "/account/referral" },
  { label: "Blog", path: "/blog" },
  { label: "Cultural Festivals & Events", path: "/ma-agent" },
  { label: "Mamapurse", path: "/account/mamapurse" },
  { label: "Track my Order", path: "/account/orders" },
  { label: "Open a Store", path: "/become-a-seller" },
];
